import * as t from "io-ts";
import { BaseId } from "./BaseId";
import { RateRequest } from "./RateRequest";

export const Enrolment = t.intersection([
  BaseId,
  t.type({
    rate_request: RateRequest,
  }),
]);

export type Enrolment = BaseId & {
  rate_request: RateRequest;
};
